import { MotionGlobalConfig } from 'motion-utils';
import { stepsOrder } from './order.mjs';
import { createRenderStep } from './render-step.mjs';
var maxElapsed = 40;

function createRenderBatcher(scheduleNextBatch, allowKeepAlive) {
  var runNextFrame = false;
  var useDefaultElapsed = true;
  var state = {
    delta: 0.0,
    timestamp: 0.0,
    isProcessing: false
  };

  var flagRunNextFrame = function flagRunNextFrame() {
    return runNextFrame = true;
  };

  var steps = stepsOrder.reduce(function (acc, key) {
    acc[key] = createRenderStep(flagRunNextFrame, allowKeepAlive ? key : undefined);
    return acc;
  }, {});
  var setup = steps.setup,
      read = steps.read,
      resolveKeyframes = steps.resolveKeyframes,
      preUpdate = steps.preUpdate,
      update = steps.update,
      preRender = steps.preRender,
      render = steps.render,
      postRender = steps.postRender;

  var processBatch = function processBatch() {
    var timestamp = MotionGlobalConfig.useManualTiming ? state.timestamp : performance.now();
    runNextFrame = false;

    if (!MotionGlobalConfig.useManualTiming) {
      state.delta = useDefaultElapsed ? 1000 / 60 : Math.max(Math.min(timestamp - state.timestamp, maxElapsed), 1);
    }

    state.timestamp = timestamp;
    state.isProcessing = true; // Unrolled render loop for better per-frame performance

    setup.process(state);
    read.process(state);
    resolveKeyframes.process(state);
    preUpdate.process(state);
    update.process(state);
    preRender.process(state);
    render.process(state);
    postRender.process(state);
    state.isProcessing = false;

    if (runNextFrame && allowKeepAlive) {
      useDefaultElapsed = false;
      scheduleNextBatch(processBatch);
    }
  };

  var wake = function wake() {
    runNextFrame = true;
    useDefaultElapsed = true;

    if (!state.isProcessing) {
      scheduleNextBatch(processBatch);
    }
  };

  var schedule = stepsOrder.reduce(function (acc, key) {
    var step = steps[key];

    acc[key] = function (process) {
      var keepAlive = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var immediate = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      if (!runNextFrame) wake();
      return step.schedule(process, keepAlive, immediate);
    };

    return acc;
  }, {});

  var cancel = function cancel(process) {
    for (var i = 0; i < stepsOrder.length; i++) {
      steps[stepsOrder[i]].cancel(process);
    }
  };

  return {
    schedule: schedule,
    cancel: cancel,
    state: state,
    steps: steps
  };
}

export { createRenderBatcher };